{
  "clientError": {
    "title": "Kesilapan dikesan",
    "body": {
      "line1": "Nampaknya ada masalah. Sila periksa jika anda telah menaip pautan yang betul, atau sila cuba lagi selepas beberapa minit. "
    }
  },
  "serverError": {
    "title": "Masalah dikesan",
    "body": {
      "line1": "Nampaknya ada masalah dengan 'server', dan kami sedang memperbaikinya. Sila cuba masuk semula laman ini atau cuba lagi selepas beberapa minit. Atau, dapatkan bantuan daripada perkhidmatan pelanggan di  circs@sph.com.sg"
    }
  },
  "pageNotFound": {
    "title": "Alamak!  Ada masalah.",
    "body": {
      "line1": "Laman yang anda cuba kunjungi tidak dapat diakses. Ia mungkin sudah dipadam atau tidak dapat diakses buat sementara waktu. Periksa URL jika terdapat kesilapan atau cuba kembali ke laman sebelumnya."
    }
  }
}
